import { useMemo } from 'react';
import { useRecoilState } from 'recoil';

import { useLearnMoreModalState } from '@/context';
import { useTracker } from '@/hooks';

export const useLearnMoreModal = () => {
  const [state, setState] = useRecoilState(useLearnMoreModalState);
  const tracker = useTracker();

  const canGoPrev = useMemo(() => state.current > 0, [state.current]);
  const canGoNext = useMemo(() => state.current < state.totalOptions - 1, [state.current]);

  const open = (current = 0) => {
    tracker.dispatchWithUserData('risk_onboarding_home_details_clicked');
    setState((old) => ({ ...old, isOpen: true, current }));
  };

  const close = () => {
    tracker.dispatchWithUserData('risk_onboarding_home_details_closed');
    setState((old) => ({ ...old, isOpen: false, current: 0 }));
  };

  const next = () => {
    if (!canGoNext) return close();
    setState((old) => ({ ...old, current: old.current + 1 }));
  };

  const prev = () => {
    if (!canGoPrev) return;
    setState((old) => ({ ...old, current: old.current - 1 }));
  };

  return {
    canGoPrev,
    canGoNext,
    totalSteps: state.totalOptions,
    current: state.current,
    isOpen: state.isOpen,
    open,
    close,
    next,
    prev,
  };
};
